import * as fb from '@/firebase'
import router from '@/router/index'

const state = {
    currentUserData: null,
    currentUserDataLoading: false
};

// mutations
const mutations = {
    SET_USER_PROFILE(state, val) {
        state.currentUserData = {
            uid: val.uid,
            email: val.email
        }
    },
    SET_CURRENT_USER_DATA_LOADING: (state, currentUserDataLoading) => {
        state.currentUserDataLoading = currentUserDataLoading;
    }
};


const actions = {
    async login({ commit, dispatch }, form) {
        try {
            dispatch('notify/hide', null, { root: true });
            commit('SET_CURRENT_USER_DATA_LOADING', true);

            // sign user in
            const { user } = await fb.auth.signInWithEmailAndPassword(form.email, form.password)

            commit('SET_CURRENT_USER_DATA_LOADING', false);
            if (!!user) {
                commit('SET_USER_PROFILE', user)
            } else {
                const notify = {
                    message:
                        'لم نتمكن من جلب بيانات المستخدم !',
                };
                dispatch('notify/show', notify, { root: true });
            }

        } catch (error) {
            commit('SET_CURRENT_USER_DATA_LOADING', false);
            const notify = {
                message:
                    error || 'error',
            };
            dispatch('notify/show', notify, { root: true });
        }

    },
    async onLogout({ commit, dispatch }) {
        try {
            dispatch('notify/hide', null, { root: true });
            commit('SET_CURRENT_USER_DATA_LOADING', true);

            await fb.auth.signOut()
            router.push('/login')

            setTimeout(() => {
                commit('SET_CURRENT_USER_DATA_LOADING', false);
            }, 1000);
        } catch (error) {
            commit('SET_CURRENT_USER_DATA_LOADING', false);
            const notify = {
                message:
                    error,
            };
            dispatch('notify/show', notify, { root: true });
        }
    },
    async fetchcurrentUserData({ commit }, user) {
        // set user profile in state
        commit('SET_USER_PROFILE', user)
        // change route to dashboard
        if (router.currentRoute.path === '/' || router.currentRoute.path === '/login') {
            router.push('/app/home')
        }
    }

}

// getters
const getters = {
    loggedIn: state => !!state.currentUserData,
    currentUserData: state => state.currentUserData,
    currentUserDataLoading: state => state.currentUserDataLoading
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
